<template>

  <div style="position: absolute;top:3px;right: 3px;z-index:99">
    <el-radio-group v-model="queryParam.date_range" name="date_range" size="small" @change="getRankData" >
      <el-radio-button label="month_current" >本月</el-radio-button>
      <el-radio-button label="month_pre" >上个月</el-radio-button>
      <el-radio-button label="month_3" >近3个月</el-radio-button>
      <el-radio-button label="month_6" >近半年</el-radio-button>
      <el-radio-button label="month_12" >近1年</el-radio-button>
    </el-radio-group>
  </div>

  <div style="position: absolute;top:33px;right: 3px;z-index:99">
    <el-radio-group v-model="queryParam.target" size="small"  @change="getRankData" >
      <el-radio-button label="user" >用户</el-radio-button>
      <el-radio-button label="department" >部门</el-radio-button>
    </el-radio-group>
  </div>

  <div id="chartContainer" style="width: 100%;height: 100%"></div>

</template>


<script>

import * as echarts from 'echarts';

export default {
  name: "SalesRank",
  data() {
    return {
      queryParam: {date_range: 'month_current', target: 'user'},
      companyList: [],
      options: {
        title: {
          text: '销售排行榜'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01]
        },
        yAxis: {
          type: 'category',
          data: ['张三', '李四', '王五', '赵六', '余冰', '金杨','张三1', '李四1', '王五1', '赵六1', '余冰1', '金杨1', '张三', '李四', '王五', '赵六', '余冰', '金杨','张三1', '李四1', '王五1', '赵六1', '余冰1', '金杨1']
        },
        series: [
          {
            name: '营业额(万)',
            type: 'bar',
            data: [0, 0, 5, 6, 12, 13,14, 22, 25, 33, 35, 40, 42, 45, 46, 48, 49, 53,68, 77, 88, 89, 101, 123]
          }
        ]
      }
    }
  },
  methods: {
    async getRankData() {
      //查询数据
      let rtn = await this.$http('crmReportService.getSalesRankData', this.queryParam)
      if(!rtn || !rtn.user_list){
        return;
      }

      //赋值
      this.options.yAxis.data = rtn.user_list;
      this.options.series[0].data = rtn.amount_list;
      this.drawChart();

    },
    drawChart(){
      var chartDom = document.getElementById('chartContainer');
      var myChart = echarts.init(chartDom);
      myChart.setOption(this.options);
    }
  },
  mounted() {
    this.getRankData();
  }
}
</script>


<style lang="less" scoped>
@import 'src/global';

.myContainer {
  padding: 5px;
}

.baidu-map-view{
  width: 100%;
  height: 100%;
}

</style>
